import React from "react";
import {
  TextField,
  Stack,
  Columns,
  Column,
  Text,
} from "@origin-digital/ods-core";
import { Field, FieldInputProps, FieldMetaProps } from "formik";
import { FormValues } from "../types";
import HelperText from "../FormComponents/HelperText";

const HomeUserPreInstaller = ({
  text,
}: {
  text?: string | React.ReactNode;
}) => {
  return (
    <Stack space="large">
      <Columns
        collapseBelow="md"
        space={{ xs: "none", md: "xlarge" }}
        alignY="stretch"
      >
        <Column width="2/3">
          <Stack space="large">
            <Text weight="medium">Pre-installer (Optional)</Text>
            <Stack
              space={{
                xs: "xlarge",
                md: "xxlarge",
              }}
            >
              <Columns
                collapseBelow="sm"
                space={{
                  xs: "xlarge",
                  lg: "large",
                }}
              >
                <Column>
                  <Field name={`internetPreInstaller.first_name`}>
                    {({
                      field,
                      meta,
                    }: {
                      field: FieldInputProps<string>;
                      meta: FieldMetaProps<FormValues>;
                    }) => {
                      return (
                        <TextField
                          {...field}
                          id={field.name}
                          variant="outlined"
                          label="First name"
                          hideHelperTextSpace
                          error={!!meta.error}
                          helperText={meta.error}
                        />
                      );
                    }}
                  </Field>
                </Column>
                <Column>
                  <Field name={`internetPreInstaller.last_name`}>
                    {({
                      field,
                      meta,
                    }: {
                      field: FieldInputProps<string>;
                      meta: FieldMetaProps<FormValues>;
                    }) => (
                      <TextField
                        {...field}
                        id={field.name}
                        variant="outlined"
                        label="Last name"
                        hideHelperTextSpace
                        error={!!meta.error}
                        helperText={meta.error}
                      />
                    )}
                  </Field>
                </Column>
              </Columns>
              <Field name={`internetPreInstaller.phone_number`}>
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Phone"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
              <Field name={`internetPreInstaller.email`}>
                {({
                  field,
                  meta,
                }: {
                  field: FieldInputProps<string>;
                  meta: FieldMetaProps<FormValues>;
                }) => (
                  <TextField
                    {...field}
                    id={field.name}
                    variant="outlined"
                    label="Email"
                    hideHelperTextSpace
                    error={!!meta.error}
                    helperText={meta.error}
                  />
                )}
              </Field>
            </Stack>
          </Stack>
        </Column>
        <Column width="1/3">{text && <HelperText text={text} />}</Column>
      </Columns>
    </Stack>
  );
};

export default HomeUserPreInstaller;
